import {
  addministrator,
  profileTextBox,
  saveContact,
  saveAddress,
} from "./form-field-name";
import { addressRegex, cityRegex, scrollToErrorField } from "utils";
interface ValidationRules {
  regex: RegExp;
  errorMessage: string;
}

interface FieldNames {
  email: string[];
  phone: string[];
  name: string[];
  address: string[];
  cityState: string[];
}

const validationRules: Record<string, ValidationRules> = {
  email: {
        regex: /.+/,
    errorMessage: "Invalid email format.",
  },
  phone: {
    regex: /^\d{8,15}$/,
    errorMessage:
      "Phone number must be 8-15 digits long and contain only numbers.",
  },
  // name: {
  //   regex: /^[\p{L}\s]+$/u,
  //   errorMessage:
  //     "This field should not contain special characters and numeric.",
  // },
  // address: {
  //   regex: addressRegex,
  //   errorMessage: "Please add a valid address.",
  // },
  // cityState: {
  //   // const regex = /^[A-Za-z\s-]+$/;
  //   // const prohibitedEntries = ["NA", "N/A"];
  //   regex: cityRegex,
  //   errorMessage: "Please enter a valid name.",
  // },
};

const fieldNames: FieldNames = {
  email: ["email", "emailsavedContacts"],
  phone: [
    "phone",
    "phNumAlternativesavedContacts",
    "phNumsavedContacts",
    "phNum",
    "phNumAlternative",
    "shpcontphone",
  ],
  name: [
    "firstname",
    "shpcontname",
    "firstNamesavedContacts",
    "lastname",
    "lastNamesavedContacts",
  ],
  address: ["addressline1", "address1_line1", "addressline2", "addressline3", "address1_line3", "address1_line2"],
  cityState: ["phCity", "phState", "address1_city", "address1_stateorprovince"],
};

export const validateForm = (
  formState: any,
  module: string = "saveContact",
  t: any
) => {
  validationRules.email.errorMessage = t('HPI.ErrorMessage.InvalidEmailFormat',{defaultValue:'Invalid email format'});
  validationRules.phone.errorMessage = t('HPI.ErrorMessage.InvalidNumber',{defaultValue:'Phone number must be 8-15 digits long and contain only numbers.'});
  const newErrorState: Record<string, string> = {};
  let allTextBoxNames = Object.keys(profileTextBox);
  let firstErrorField :string| null = null;
  if (module === "saveContact") {
    allTextBoxNames = saveContact;
  } else if (module === "profile") {
    allTextBoxNames = profileTextBox;
    if (formState["countryName"] === "Japan") {
      allTextBoxNames.push("alternatefirstname");
      allTextBoxNames.push("alternatelasttname");
    } else {
      allTextBoxNames = allTextBoxNames.filter(
        (name) => name !== "alternatefirstname" && name !== "alternatelasttname"
      );
    }
  } else if (module === "addministrator") {
    allTextBoxNames = addministrator;
  } else if (module === "saveAddress") {
    allTextBoxNames = saveAddress;
  }

  allTextBoxNames.forEach((fieldName) => {
    const value = formState[fieldName] || "";
    if ((!value || value === '-1')&& fieldName !== "" ) {
      newErrorState[fieldName] = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
      if(!firstErrorField){
        firstErrorField = fieldName
      }
      return;
    }
  
    for (let ruleKey in validationRules) {
      if (fieldNames[ruleKey as keyof FieldNames].includes(fieldName)) {
        const { regex, errorMessage } = validationRules[ruleKey];
        if (value && !regex.test(value)) {
          newErrorState[fieldName] = errorMessage;
        }
        break;
      }
    }
  });
  
  if(newErrorState){
    scrollToErrorField(firstErrorField)
  }
  return newErrorState;
};

export const validateField = (
  name: string,
  value: string,
  setErrorState: (prevState: any) => void,
  t:any
) => {
  validationRules.email.errorMessage = t('HPI.ErrorMessage.InvalidEmailFormat',{defaultValue:'Invalid email format'});
  validationRules.phone.errorMessage = t('HPI.ErrorMessage.InvalidNumber',{defaultValue:'Phone number must be 8-15 digits long and contain only numbers.'});
  let error = "";
  if (!value) {
    error = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
  }

  for (let ruleKey in validationRules) {
    if (fieldNames[ruleKey as keyof FieldNames].includes(name)) {
      const { regex, errorMessage } = validationRules[ruleKey];
      if (value && !regex.test(value)) {
        error = errorMessage;
      }
      break;
    }
  }

  setErrorState((prevState: any) => ({
    ...prevState,
    [name]: error,
  }));
};
